<div
  class="grid items-center"
  [ngStyle]="{
    'grid-template-columns':
      showLineColor() && color() ? 'max-content 1fr' : '1fr',
  }">
  @if (showLineColor() && color()) {
    <div
      class="project-line me-2"
      [style]="{ 'background-color': color() }"></div>
  }
  <div
    class="my-2 grid items-center"
    [style]="{ color: color() }"
    [ngStyle]="{ 'grid-template-columns': icon() ? 'max-content 1fr' : '1fr' }">
    @if (icon()) {
      <mat-icon class="me-1">{{ icon() }}</mat-icon>
    }
    {{ name() }}
  </div>
</div>
